export enum AccessIdentifier {
    None = 0,
    View = 1,
    Edit = 2,
    Yes = 3,
    No = 4,
    YesWithWarning = 5,
    SiteSpecified = 6,
    NotSpecified = 7,
    All = 8,
    Basic = 9,
}

export enum UserAccess {
    // User Type
    superAdmin = 'SUPER_ADMIN',
    nzmbStaff = 'NZMB_STAFF',
    exporter = 'EXPORTER',
    auditorQCVS = 'AUDITOR_QCVS',
    auditorPH = 'AUDITOR_PH',

    allowLogin = 'ALLOW_LOGIN',
    exporterManager = 'ACCOUNT_MANAGER',

    //QUOTA Allocator
    hasQuotaAllocator = 'QUOTA_ALLOCATOR',
    viewQuotaAllocator = 'VIEW_QUOTA_ALLOCATOR',
    editQuotaAllocator = 'EDIT_QUOTA_ALLOCATOR',

    //Allow Certificate Issue Wgtn
    allowCertificateIssueWgtn = 'ALLOW_CERTIFICATE_ISSUE_WGTN',
    allowCertificateIssueWgtnWithWarning = 'ALLOW_CERTIFICATE_ISSUE_WGTN_WITH_WARNING',
    // allowCertificateIssueWgtnWithNo = 'ALLOW_CERTIFICATE_ISSUE_WGTN_WITH_NO',

    //Allow Certificate Issue Brs
    allowCertificateIssueBrs = 'ALLOW_CERTIFICATE_ISSUE_BRS',
    allowCertificateIssueBrsWithWarning = 'ALLOW_CERTIFICATE_ISSUE_BRS_WITH_WARNING',
    // allowCertificateIssueBrsWithNo = 'ALLOW_CERTIFICATE_ISSUE_BRS_WITH_NO',

    //Ecertissue
    allowEcertissueSiteSpecified = 'ALLOW_ECERTISSUE_SITE_SPECIFIED',
    allowEcertissueNotSpecified = 'ALLOW_ECERTISSUE_NOT_SPECIFIED',
    allowEcertissueAll = 'ALLOW_ECERTISSUE_ALL',

    //Allow Setup Quota
    hasQuotaSetup = 'QUOTA_SETUP',
    viewQuotaSetup = 'VIEW_QUOTA_SETUP',
    editQuotaSetup = 'EDIT_QUOTA_SETUP',

    //Allow Setup Organization
    hasOrganizationSetup = 'ORGANIZATION_SETUP',
    viewOrganizationSetup = 'VIEW_ORGANIZATION_SETUP',
    editOrganizationSetup = 'EDIT_ORGANIZATION_SETUP',

    //Allow Setup User
    hasUserSetup = 'USER_SETUP',
    viewUserSetup = 'VIEW_USER_SETUP',
    editUserSetup = 'EDIT_USER_SETUP',

    //Allow Setup Fees
    hasFeesSetup = 'FEES_SETUP',
    viewFeesSetup = 'VIEW_FEES_SETUP',
    editFeesSetup = 'EDIT_FEES_SETUP',

    //Voyages
    hasVoyages = 'VOYAGES',
    viewVoyages = 'VIEW_VOYAGES',
    editVoyages = 'EDIT_VOYAGES',

    //Importers
    hasImporters = 'IMPORTERS',
    viewImporters = 'VIEW_IMPORTERS',
    editImporters = 'EDIT_IMPORTERS',

    //Production History
    hasProductionHistory = 'PRODUCTION_HISTORY',
    viewProductionHistory = 'VIEW_PRODUCTION_HISTORY',
    editProductionHistory = 'EDIT_PRODUCTION_HISTORY',

    //Exporter History
    hasExporterHistory = 'EXPORTER_HISTORY',
    viewExporterHistory = 'VIEW_EXPORTER_HISTORY',
    editExporterHistory = 'EDIT_EXPORTER_HISTORY',

    //Audit
    hasAudit = 'AUDIT',
    viewAudit = 'VIEW_AUDIT',
    editAudit = 'EDIT_AUDIT',

    //Communication
    hasCommunication = 'COMMUNICATION',
    viewCommunication = 'VIEW_COMMUNICATION',
    editCommunication = 'EDIT_COMMUNICATION',

    //Reports
    hasReports = 'REPORTS',
    viewReports = 'VIEW_REPORTS',
    editReports = 'EDIT_REPORTS',

    //Functions
    allowCertificateRequest = 'ALLOW_CERTIFICATE_REQUEST',
    allowQuotaApplication = 'ALLOW_QUOTA_APPLICATION',
    allowHandBack = 'ALLOW_HAND_BACK',
    allowTransfer = 'ALLOW_TRANSFER',

    //System Settings
    allowSystemSettings = 'ALLOW_SYSTEM_SETTINGS',
    isBasicAdmin = 'IS_BASIC_USER',
    advancedSystemSettings = 'ADVANCED_SYSTEM_SETTINGS'

}